import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SchemaOrg, { getOrganizationSchema, getFAQSchema } from '@/components/feature/SchemaOrg';
import { categories } from '@/mocks/categories';

const testimonials = [
  {
    name: '张先生',
    role: '资深影迷',
    content: '私密视频真的太方便了！以前要在好几个平台之间切换，现在一个网站就能看到红桃视频、西瓜视频的所有内容，画质清晰还不缓冲，强烈推荐！',
    rating: 5,
  },
  {
    name: '李女士',
    role: '追剧达人',
    content: '作为芒果视频和小蓝视频的忠实用户，私密视频帮我把所有资源聚合到一起，再也不用下载多个APP了。流畅度真的没得说！',
    rating: 5,
  },
  {
    name: '王先生',
    role: '家庭用户',
    content: '家里老人小孩都喜欢看视频，私密视频的分类很清楚，操作也简单。茄子视频和久久视频的经典内容老人特别喜欢。',
    rating: 5,
  },
  {
    name: '赵女士',
    role: '上班族',
    content: '通勤路上用手机看，午休用电脑看，画质自动适配。私密视频的智能码率技术真的做到了"不缓冲"的承诺。',
    rating: 5,
  },
  {
    name: '陈同学',
    role: '大学生',
    content: '宿舍网络不太好，但在私密视频上看视频基本不卡。资源也很全，追番追剧一站式搞定，室友都被我安利了！',
    rating: 4,
  },
  {
    name: '刘先生',
    role: '自由职业者',
    content: '从红桃视频到西瓜视频，各大平台的优质内容在私密视频上都能找到。界面简洁没有广告弹窗，观影体验很棒。',
    rating: 5,
  },
];

const stats = [
  { label: '聚合平台', value: '6+', icon: 'ri-stack-line' },
  { label: '视频资源', value: '10万+', icon: 'ri-video-line' },
  { label: '日均用户', value: '50万+', icon: 'ri-user-line' },
  { label: '用户好评', value: '98%', icon: 'ri-thumb-up-line' },
];

export default function AboutPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const aboutSchema = {
    name: '私密视频 - 关于我们',
    description: '私密视频品牌介绍、用户口碑与联系方式。聚合红桃视频、西瓜视频、小蓝视频、茄子视频、久久视频、芒果视频等平台资源。',
    url: 'https://www.simishipin.com/about',
    inLanguage: 'zh-CN',
  };

  return (
    <>
      <SchemaOrg type="WebPage" data={aboutSchema} />
      <SchemaOrg type="Organization" data={getOrganizationSchema()} />
      <SchemaOrg type="FAQPage" data={getFAQSchema()} />

      <Navbar />

      <main className="pt-16">
        <Breadcrumb
          items={[
            { label: '首页', href: '/' },
            { label: '关于我们' },
          ]}
        />

        <section className="px-4 md:px-6 py-10 md:py-16 bg-background-50">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-3xl md:text-5xl font-heading font-bold text-foreground-900 mb-4">
              关于私密视频
            </h1>
            <p className="text-base md:text-lg text-foreground-600 max-w-2xl mx-auto leading-relaxed">
              私密视频是行业领先的综合视频聚合平台，致力于为用户提供一站式的视频观看体验。
              我们聚合红桃视频、西瓜视频、小蓝视频、茄子视频、久久视频、芒果视频等六大平台的优质资源，
              让您在同一个平台畅享全网视频内容。
            </p>
          </div>
        </section>

        <section className="px-4 md:px-6 py-10 md:py-14 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 md:gap-6">
              {stats.map((stat) => (
                <div key={stat.label} className="text-center p-6 bg-background-50 rounded-xl border border-background-200/70">
                  <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3 rounded-xl bg-primary-100">
                    <i className={`${stat.icon} text-xl text-primary-600`}></i>
                  </div>
                  <div className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-1">
                    {stat.value}
                  </div>
                  <div className="text-xs md:text-sm text-foreground-600">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="px-4 md:px-6 py-10 md:py-14 bg-background-50">
          <div className="max-w-4xl mx-auto">
            <div className="mb-8 text-center">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
                品牌故事
              </h2>
              <p className="text-sm text-foreground-600">为用户提供最好的视频聚合服务</p>
            </div>
            <div className="prose max-w-none">
              <div className="bg-background-100 rounded-xl p-6 md:p-8 border border-background-200/70">
                <h3 className="text-xl font-heading font-bold text-foreground-900 mb-4">我们的使命</h3>
                <p className="text-foreground-700 leading-relaxed mb-4">
                  私密视频成立的初衷，是解决视频用户需要在多个平台之间来回切换的痛点。
                  我们深知，每一位用户都希望能够在一个平台上找到所有想看的视频内容——
                  无论是<strong>红桃视频</strong>的高品质影视，<strong>西瓜视频</strong>的海量免费资源，
                  还是<strong>小蓝视频</strong>的独家内容，<strong>茄子视频</strong>的动漫佳作，
                  <strong>久久视频</strong>的经典珍藏，或是<strong>芒果视频</strong>的热门综艺。
                </p>

                <h3 className="text-xl font-heading font-bold text-foreground-900 mb-4">核心技术</h3>
                <p className="text-foreground-700 leading-relaxed mb-4">
                  我们投入大量研发资源，打造了智能码率自适应技术和全球CDN加速网络。
                  无论您使用什么设备、在什么网络环境下，私密视频都能提供<strong>高清画质不缓冲</strong>的流畅观影体验。
                  同时，我们的AI推荐算法能够精准匹配您的观影偏好，帮助您发现更多优质内容。
                </p>

                <h3 className="text-xl font-heading font-bold text-foreground-900 mb-4">用户至上</h3>
                <p className="text-foreground-700 leading-relaxed">
                  私密视频始终坚持"用户至上"的理念。我们提供<strong>免费在线观看</strong>服务，
                  不强制注册，不捆绑广告，让每一位用户都能享受到纯净的观影体验。
                  同时，我们高度重视用户隐私保护，采用银行级加密技术保障您的观影数据安全。
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="px-4 md:px-6 py-10 md:py-14 bg-background-100">
          <div className="max-w-4xl mx-auto">
            <div className="mb-8 text-center">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
                用户口碑
              </h2>
              <p className="text-sm text-foreground-600">来自真实用户的评价与反馈</p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
              {testimonials.map((item) => (
                <div key={item.name} className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/70">
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i
                        key={i}
                        className={`text-sm ${i < item.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'}`}
                      ></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                    &ldquo;{item.content}&rdquo;
                  </p>
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 font-heading font-bold text-sm">
                      {item.name.charAt(0)}
                    </div>
                    <div>
                      <div className="text-sm font-medium text-foreground-900">{item.name}</div>
                      <div className="text-xs text-foreground-500">{item.role}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="px-4 md:px-6 py-10 md:py-14 bg-background-50">
          <div className="max-w-4xl mx-auto">
            <div className="mb-8 text-center">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
                联系我们
              </h2>
              <p className="text-sm text-foreground-600">期待与您的沟通交流</p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
              <div>
                <div className="bg-background-100 rounded-xl p-6 md:p-8 border border-background-200/70 h-full">
                  <h3 className="text-lg font-heading font-bold text-foreground-900 mb-4">联系方式</h3>
                  <ul className="space-y-4">
                    <li className="flex items-start gap-3">
                      <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-100 shrink-0">
                        <i className="ri-phone-line text-primary-600"></i>
                      </div>
                      <div>
                        <div className="text-sm font-medium text-foreground-900">客服热线</div>
                        <div className="text-sm text-foreground-600">400-000-0000</div>
                      </div>
                    </li>
                    <li className="flex items-start gap-3">
                      <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-100 shrink-0">
                        <i className="ri-mail-line text-accent-600"></i>
                      </div>
                      <div>
                        <div className="text-sm font-medium text-foreground-900">电子邮箱</div>
                        <div className="text-sm text-foreground-600">contact@simishipin.com</div>
                      </div>
                    </li>
                    <li className="flex items-start gap-3">
                      <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-100 shrink-0">
                        <i className="ri-map-pin-line text-secondary-600"></i>
                      </div>
                      <div>
                        <div className="text-sm font-medium text-foreground-900">公司地址</div>
                        <div className="text-sm text-foreground-600">北京市朝阳区建国路88号SOHO现代城A座</div>
                      </div>
                    </li>
                    <li className="flex items-start gap-3">
                      <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-100 shrink-0">
                        <i className="ri-time-line text-primary-600"></i>
                      </div>
                      <div>
                        <div className="text-sm font-medium text-foreground-900">工作时间</div>
                        <div className="text-sm text-foreground-600">周一至周日 9:00 - 22:00</div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>

              <div>
                <div className="bg-background-100 rounded-xl p-6 md:p-8 border border-background-200/70 h-full">
                  <h3 className="text-lg font-heading font-bold text-foreground-900 mb-4">快速链接</h3>
                  <div className="grid grid-cols-2 gap-3">
                    {categories.map((cat) => (
                      <Link
                        key={cat.slug}
                        to={`/category/${cat.slug}`}
                        className="flex items-center gap-2 px-4 py-3 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/50 transition-all duration-200 text-sm font-medium text-foreground-700 hover:text-primary-600 whitespace-nowrap"
                      >
                        <i className={`${cat.icon} text-base`}></i>
                        {cat.name}
                      </Link>
                    ))}
                  </div>
                  <div className="mt-6">
                    <h4 className="text-sm font-medium text-foreground-900 mb-3">关注我们</h4>
                    <div className="flex items-center gap-3">
                      <a href="#" className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-50 border border-background-200/70 hover:bg-primary-500 hover:text-white text-foreground-600 transition-all duration-200" aria-label="微博">
                        <i className="ri-weibo-line text-lg"></i>
                      </a>
                      <a href="#" className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-50 border border-background-200/70 hover:bg-primary-500 hover:text-white text-foreground-600 transition-all duration-200" aria-label="微信">
                        <i className="ri-wechat-line text-lg"></i>
                      </a>
                      <a href="#" className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-50 border border-background-200/70 hover:bg-primary-500 hover:text-white text-foreground-600 transition-all duration-200" aria-label="QQ">
                        <i className="ri-qq-line text-lg"></i>
                      </a>
                      <a href="#" className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-50 border border-background-200/70 hover:bg-primary-500 hover:text-white text-foreground-600 transition-all duration-200" aria-label="B站">
                        <i className="ri-bilibili-line text-lg"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="px-4 md:px-6 py-12 md:py-16 relative overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=A%20warm%20abstract%20gradient%20with%20soft%20flowing%20shapes%20in%20deep%20red%20and%20dark%20amber%2C%20modern%20streaming%20platform%20background%2C%20elegant%20minimal%20design&width=1800&height=600&seq=cta-bg-about&orientation=landscape"
            alt=""
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/60 to-black/40"></div>
          <div className="relative z-10 max-w-2xl mx-auto text-center">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-white mb-3">
              立即体验高清观影
            </h2>
            <p className="text-sm md:text-base text-white/80 mb-6">
              六大平台资源一站畅享，免费在线观看，高清画质不缓冲
            </p>
            <Link
              to="/"
              className="inline-flex px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white rounded-full font-medium transition-all duration-300 whitespace-nowrap"
            >
              <i className="ri-play-circle-line mr-2"></i>开始观看
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}